"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavStyles = exports.MenuButtonIconStyles = void 0;
const MenuButtonIconStyles = theme => {
    return {
      color: theme.mixins.navigation.mobile.buttonIconColor,
      fontSize: "1.6rem",
      height: "5.3rem",
      width: "5.3rem"
    };
  },
  NavStyles = () => {
    return {
      width: "30rem"
    };
  };
exports.NavStyles = NavStyles;
exports.MenuButtonIconStyles = MenuButtonIconStyles;